<template>
    <div id="update_provider_services">
        <form id="update_providers_settings_form">
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#inquiry_services_tab"
                           @click="gotoTab(1)">
                            {{ $t('application.services.inquiry_services') }}
                        </a>
                    </li>
<!--                    <li class="nav-item">-->
<!--                        <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#authentication_services_tab"-->
<!--                           @click="gotoTab(2)">-->
<!--                            {{ $t('application.services.authentication_services') }}-->
<!--                        </a>-->
<!--                    </li>-->
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#financial_services_tab"
                           @click="gotoTab(3)">
                            {{ $t('application.services.financial_services') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
            <div class="tab-content">
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 1 ? 'active' : '']">
                        <kt-col v-if="settings" lg="12" md="12" sm="12">
                            <application-services :services="inquiryServices"
                                                  :settings="settings"
                                                  :service_bank_providers="service_bank_providers"
                            ></application-services>
                        </kt-col>
                    </div>
<!--                    <div :class="['tab-pane', currentTab === 2 ? 'active' : '']">-->
<!--                        <kt-col v-if="settings" lg="12" md="12" sm="12">-->
<!--                            <application-services :services="authenticationServices"-->
<!--                                                  :settings="settings"-->
<!--                                                  :service_bank_providers="service_bank_providers"-->
<!--                            ></application-services>-->
<!--                        </kt-col>-->
<!--                    </div>-->
                    <div :class="['tab-pane', currentTab === 3 ? 'active' : '']">
                        <kt-col v-if="settings" lg="12" md="12" sm="12">
                            <financial-services :all_services="financialServices"
                                                :settings="settings"
                                                :service_bank_providers="service_bank_providers"
                            ></financial-services>
                        </kt-col>
                    </div>
                </div>
            </div>
        </form>
        <kt-col lg="12" style="margin-top: 60px">
            <kt-form-action class="mt-4">
                <kt-button
                    style="position: absolute;left: 0;bottom: 0"
                    class="m-2 btn-wide"
                    size="md"
                    variant="success"
                    type="button"
                    v-bind:wide="true"
                    id="update_providers_settings_btn"
                    @click="updateProvidersSettings()"
                >
                    {{ $t('btn.edit') }}
                </kt-button>
            </kt-form-action>
        </kt-col>
    </div>

</template>

<script>
import {
    services,
    providerType,
    providerTypeStr,
    financialServices,
    authenticationServices,
    inquiryServices,
    changeableWageServices
} from '@/constants/openBanking';
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import toastr from "toastr";
import {i18n} from '@/plugins/i18n';
import applicationServices from './application-services'
import FinancialServices from './financial-services.vue'
import {openBankingService} from "@/common/api.service";


export default {
    components: {
        'application-services': applicationServices,
        'financial-services': FinancialServices,
    },
    props: {
        settings: {
            required: true,
        },
        service_bank_providers: {
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    data() {
        return {
            providerType,
            providerTypeStr,
            financialServices,
            changeableWageServices,
            // authenticationServices,
            // inquiryServices,
            currentTab: 1,
        }
    },
    computed: {
      inquiryServices() {
         return {...inquiryServices,  ...authenticationServices};
      },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        updateProvidersSettings() {
            let form = $('#update_providers_settings_form')
            let btn = $('#update_providers_settings_btn')
            let rules = {};
            let auth_inquiry_services = {...this.inquiryServices, ...this.authenticationServices}
            Object.values(auth_inquiry_services).forEach(value => {
                Object.values(this.getProviders(value)).forEach(provider => {
                    rules[value + '_' + provider + '_company_wage'] = {required: true};
                    rules[value + '_' + provider + '_provider_wage'] = {required: true};
                })
            })
            Object.values(this.financialServices).forEach(service => {
                Object.values(this.getProviders(service)).forEach(bank => {
                    Object.values(this.getServiceBankProvider(service, bank)).forEach(provider => {
                        if ( Object.values(this.changeableWageServices).includes(service)) {
                            rules[service + '_' + bank + '_' + provider + '_company_wage_type'] = {required: true};
                            rules[service + '_' + bank + '_' + provider + '_provider_wage_type'] = {required: true};
                            if (this.settings[service][bank][provider].company_wage_type == 2) {//percentage
                                rules[service + '_' + bank + '_' + provider + '_company_min_wage'] = {required: true};
                                rules[service + '_' + bank + '_' + provider + '_company_max_wage'] = {required: true};
                            }
                            if (this.settings[service][bank][provider].provider_wage_type == 2) {//percentage
                                rules[service + '_' + bank + '_' + provider + '_provider_min_wage'] = {required: true};
                                rules[service + '_' + bank + '_' + provider + '_provider_max_wage'] = {required: true};
                            }

                        }
                        rules[service + '_' + bank + '_' + provider + '_company_wage'] = {required: true};
                        rules[service + '_' + bank + '_' + provider + '_provider_wage'] = {required: true};
                    })
                })
            })

            form.validate({
                rules: rules,
                invalidHandler: function (form, validator) {
                    console.log('Validation errors:');
                    $.each(validator.errorList, function (index, error) {
                        console.log(error.message + ' for element: ' + error.element.name);
                    });

                    console.log('Validator object:', validator);
                },
            })

            if (!form.valid()) {
                return this.toastr.error(i18n.t('open_banking.message.fill_all'))
            }

            KTApp.progress(btn)
            openBankingService.adminUpdateProvidersSettings(this.settings).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                    KTApp.unprogress(btn)
                }
            )
        },
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_chose')
            })
        },
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
        },
        getProviders(service) {
            return Object.keys(this.service_bank_providers[service])
        },
        getServiceBankProvider(service, bank) {
            return this.service_bank_providers[service][bank]
        },
    }
}
</script>

<style>
.modal .modal-content .modal-header .close:before {
    content: "" !important;
}

.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: .7;
}
</style>